import { CART_BASE, CART_ITEM } from 'cart/constants/paths';
import EditCartItemRouteContainer from 'cart/containers/EditCartItemRouteContainer';
import MenuItemPageLayout from 'menus/layouts/MenuItemLayout';
import CartRouteContainer from 'cart/containers/CartRouteContainer';
import CartPageLayout from 'cart/layouts/CartPageLayout';

const routes = [
  {
    path: CART_BASE,
    exact: true,
    Component: CartRouteContainer,
    Layout: CartPageLayout
  },
  {
    path: CART_ITEM,
    exact: true,
    Component: EditCartItemRouteContainer,
    Layout: MenuItemPageLayout
  }
];

export default routes;
